export default "__VITE_ASSET__DAULEdRc__"